import { environment } from '../environments/environment';

export const ENDPOINTS = {
  users: {
    register: environment.api_url + 'users/register',
    login: environment.api_url + 'users/authenticate',
    forgotten_password: environment.api_url + 'users/forgotten',
    reset_password: (token: string) =>
      environment.api_url + 'users/reset-password/' + token,
    my_acc: environment.api_url + 'myacc',
    all_admin: environment.api_url + 'admin/users',
    all: environment.api_url + 'users',
    details: (id: string) => environment.api_url + 'users/' + id,
    delete: environment.api_url + 'admin/users/',
    edit_as_admin: (id: string) => environment.api_url + 'admin/users/' + id,
    edit:  environment.api_url + 'users',
    create: environment.api_url + 'admin/users',
    all_by_clinic: (clinicId: string) =>
      environment.api_url + 'users/byClinic/' + clinicId,
  },
  pets: {
    all: environment.api_url + 'patients',
    all_byowner: (ownerId: string) =>
      environment.api_url + 'patients/byOwner/' + ownerId,
    all_byclinic: (clinicId: string) =>
      environment.api_url + 'patients/byClinic/' + clinicId,
    details: (id: string) => environment.api_url + 'patients/' + id,
    delete: environment.api_url + 'patients',
    edit: (id: string) => environment.api_url + 'patients/' + id,
    create: (ownerId: string) => environment.api_url + 'patients/' + ownerId,
  },
  clinics: {
    all: environment.api_url + 'clinics',
    details: (id: string) => environment.api_url + 'clinics/' + id,
    delete: environment.api_url + 'admin/clinics',
    edit: (id: string) => environment.api_url + 'clinics/' + id,
    create: (ownerId: string) => environment.api_url + 'clinics/' + ownerId,
  },
  stocks: {
    all: (clinicId: string) =>
      environment.api_url + 'stocks/byClinic/' + clinicId,
    details: (id: string) => environment.api_url + 'stocks/' + id,
    delete: environment.api_url + 'stocks',
    edit: (id: string) => environment.api_url + 'stocks/' + id,
    create: (clinicId: string) => environment.api_url + 'stocks/' + clinicId,
  },
  history: {
    all: (clinicId: string, patientId: string) =>
      `${environment.api_url}histories/${clinicId}/${patientId}`,
    details: (id: string) => environment.api_url + 'histories/' + id,
    delete: environment.api_url + 'histories',
    edit: (id: string) => environment.api_url + 'histories/' + id,
    create: (clinicId: string) => environment.api_url + 'histories/' + clinicId,
  },
  sales: {
    all: (clinicId: string) => environment.api_url + 'sales/' + clinicId,
    details: (id: string) => environment.api_url + 'sales/details/' + id,
    delete: environment.api_url + 'sales',
    edit: (id: string) => environment.api_url + 'sales/' + id,
    create: (clinicId: string) => environment.api_url + 'sales/' + clinicId,
  },
  search: {
    search: (type: string, query: string) =>
      environment.api_url + 'searches/' + type + '/' + query,
  },
  client: {
    details: (id: string) => environment.api_url + 'clients/details/' + id,
    delete: environment.api_url + 'clients',
    edit: (id: string) => environment.api_url + 'clients/' + id,
    create: (clinicId: string) => environment.api_url + 'clients/' + clinicId,
    all: (clinicId: string) => environment.api_url + 'clients/' + clinicId,
  },
  stats: {
    get_by_clinic: (clinicId: string, date: string) =>
      environment.api_url + 'stats/' + clinicId + '/' + date,
  },
  /*  programs: {
    all: environment.api_url + 'programs',
    details: (id: string) => environment.api_url + 'programs/' + id,
    create: environment.api_url + 'programs',
    edit: (id: string) => environment.api_url + 'programs/' + id,
    delete: (id: string) => environment.api_url + 'programs/' + id,
  }, */
};
